<template>
  <h2>NotFound</h2>
</template>

<script>
export default {
  name: 'NotFound',
  props: {
    msg: String
  }
}
</script>

<style>
</style>
